import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent],
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.css'],
})
export class ComingSoonComponent implements OnInit, OnDestroy {
  showCountdown = false;
  showEstimate = true;

  currentTime = new Date();
  targetDate = new Date();
  timeRemaining = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  estimatedTimeframe = 'Coming Soon';

  private countdownInterval: any;
  private animationInterval: any;

  features = [
    {
      icon: 'rocket',
      title: 'Enhanced Performance',
      description: 'Lightning-fast search and improved user experience',
    },
    {
      icon: 'shield',
      title: 'Advanced Security',
      description: 'State-of-the-art protection for all your transactions',
    },
    {
      icon: 'sparkles',
      title: 'Smart Features',
      description: 'AI-powered recommendations and automated tools',
    },
    {
      icon: 'users',
      title: 'Community Hub',
      description: 'Connect with buyers and sellers in your area',
    },
  ];

  progressPercentage = 75;

  constructor() {
    this.targetDate.setDate(this.targetDate.getDate() + 30);
  }

  ngOnInit(): void {
    if (this.showCountdown) {
      this.startCountdown();
    }

    this.startProgressAnimation();

    setTimeout(() => {
      document.querySelector('.coming-soon-content')?.classList.add('loaded');
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  }

  private startCountdown(): void {
    this.updateCountdown();
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  private updateCountdown(): void {
    const now = new Date().getTime();
    const target = this.targetDate.getTime();
    const difference = target - now;

    if (difference > 0) {
      this.timeRemaining = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000),
      };
    } else {
      this.timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
  }

  private startProgressAnimation(): void {
    let currentProgress = 0;
    const targetProgress = this.progressPercentage;
    const increment = targetProgress / 100;

    this.animationInterval = setInterval(() => {
      if (currentProgress < targetProgress) {
        currentProgress += increment;
        const progressBar = document.querySelector(
          '.progress-fill'
        ) as HTMLElement;
        if (progressBar) {
          progressBar.style.width = `${Math.min(
            currentProgress,
            targetProgress
          )}%`;
        }
      } else {
        clearInterval(this.animationInterval);
      }
    }, 20);
  }

  goBack(): void {
    window.history.back();
  }
}
